import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header"
import "./layout.css"
import { Link } from "gatsby"
import ThemeToggle from "./ThemeToggle"
import CookieBanner from "./CookieBanner";

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      allNamesJson {
        nodes {
          name
          amount
        }
      }
      allLastNamesJson {
        nodes {
          lastName
          amount
        }
      }
      allPopularaHundnamn2024Json {
        nodes {
          animalName
          amount
        }
      }
      allPopularaKattnamn2024Json {
        nodes {
          animalName
          amount
        }
      }
    }
  `)
  
  const allNames = data.allNamesJson.nodes.map((node) => ({
    name: node.name,
    amount: node.amount,
    type: "Förnamn",
  }))
  
  const allLastNames = data.allLastNamesJson.nodes.map((node) => ({
    name: node.lastName,
    amount: node.amount,
    type: "Efternamn",
  }))
  
  const allAnimals = [
    ...data.allPopularaHundnamn2024Json.nodes.map((node) => ({
      name: node.animalName,
      amount: node.amount,
      type: "Hundnamn",
    })),
    ...data.allPopularaKattnamn2024Json.nodes.map((node) => ({
      name: node.animalName,
      amount: node.amount,
      type: "Kattnamn",
    })),
  ];
  
  const combinedData = [...allNames, ...allLastNames, ...allAnimals]

  return (
    <>
      <ThemeToggle />
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} allData={combinedData} />
      <main>
        {children || <p>Inget innehåll tillgängligt.</p>}
      </main>
      <footer
        style={{
          marginTop: `var(--space-6)`,
          marginBottom: `var(--space-6)`,
          fontSize: `var(--font-sm)`,
          textAlign: `center`,
        }}
      >
        © {new Date().getFullYear()} 
        {` `}
        namndatabasen.se &middot; <Link to="/om-siten"> Om sidan</Link> &middot; <Link to="/cookies"> Cookies</Link>
      </footer>
      <CookieBanner />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout